import React, {useState,useEffect} from "react";
import database from '../firebase';
import './Profile.css';
import UserProfileImgDefault from "./ProfileImgDefault.png";

const db = database.firestore();
const storage = database.storage();

export default  function Profile(props) {
    const [ID] = useState(props.ID);
    const [English, setEnglish] = useState(true);
    const [UserName, setUserName] = useState("");
    const [UserIntro, setUserIntro] = useState("");
    const [UserName_, setUserName_] = useState("");
    const [UserIntro_, setUserIntro_] = useState("");

    const [UserProfileImg, setUserProfileImg] = useState(UserProfileImgDefault);
    const [image, setImage] = useState(null);
    const [Message, setMessage] = useState("haven't chosen an image")
    const [Edit, setEdit] = useState(false);

    //var img = new Image();

    useEffect(() => {
        //名字
        db.collection("users").doc(ID).get().then(function(doc){
            setUserName(doc.data().personalinfor.Name);
            setUserIntro(doc.data().personalinfor.Intro);
            setUserName_(doc.data().personalinfor.Name);
            setUserIntro_(doc.data().personalinfor.Intro);
            if (doc.data().personalinfor.ProfileImg !== "default"){
                setUserProfileImg(doc.data().personalinfor.ProfileImg)
            }
        })
    },[ID])

    //choose image
    const handleEditImg =(e)=>{
        e.preventDefault();
        if (e.target.files[0]){
            setImage(e.target.files[0]);
        }
        if (English === true){
            setMessage("image selected");
        }else{
            setMessage("已选择图片");
        }
        
    }

    const CancelEdit =()=>{
        setImage(null);

        if (English === true){
            setMessage("haven't chosen an image");
        }else{
            setMessage("还未选择图片");
        }

        var UserName_t = UserName;
        setUserName_(UserName_t)
        var UserIntro_t = UserIntro;
        setUserIntro_(UserIntro_t)
        setEdit(false);
    }

    //update
    const handleSave =(e)=>{
        e.preventDefault();
        if (image != null){
            storage.ref(ID+"/ProfileImg").put(image).then(()=>{
                storage.ref(ID).child("ProfileImg").getDownloadURL()
                .then(url=>{
                    db.collection("users").doc(ID).update({
                        "personalinfor.ProfileImg": url,
                        "personalinfor.Name": UserName_,
                        "personalinfor.Intro": UserIntro_,
                    }).then(()=>{
                        if (English === true){
                            setMessage("haven't chosen an image");
                        }else{
                            setMessage("还未选择图片");
                        }
                        setUserProfileImg(url);
                        var UserName_t = UserName_;
                        setUserName(UserName_t)
                        var UserIntro_t = UserIntro_;
                        setUserIntro(UserIntro_t)
                        setEdit(false);

                    })
                })
            })
        }else{
            db.collection("users").doc(ID).update({
                "personalinfor.Name": UserName_,
                "personalinfor.Intro": UserIntro_,
            }).then(()=>{
                if (English === true){
                    setMessage("haven't chosen an image");
                }else{
                    setMessage("还未选择图片");
                }
                var UserName_t = UserName_;
                setUserName(UserName_t)
                var UserIntro_t = UserIntro_;
                setUserIntro(UserIntro_t)
                setEdit(false);
            })
        }
    }


    const ChangeToChinese =()=>{
        if(Message === "haven't chosen an image"){
            setMessage("还未选择图片");
        }else{
            setMessage("已选择图片");
        }

        setEnglish(false);
    }

    const ChangeToEnglish =()=>{
        if (Message === "还未选择图片"){
            setMessage("haven't chosen an image");
        }else{
            setMessage("image selected")
        }

        setEnglish(true);
    }

    const handleEdit =()=>{
        setEdit(true);
    }

    return (
        <div> 
            {English?(
                <>
                {Edit?(
                    <div className="Profile">
                    <h1> Personal Information</h1>
                    <div className="Profile-Language" onClick={ChangeToChinese}> <h3>中文</h3></div>
                    
                    <div className="Profile-box">
                        <div className="Profile-Img"> 
                            <p>Profile Pocture</p>
                            <img src={UserProfileImg} alt=""/>
                            <input type="file"  onChange={handleEditImg} id="inputImg"/>
                            <label htmlFor="inputImg">Select Image</label>
                            <h6>{Message}</h6>
                        </div>

                        <div className="Profile-Infor"> 
                            <h3>Name: </h3> <input type="text" placeholder={UserName}  
                                             onChange={(e) => setUserName_(e.target.value)}/>
                            <h4>Intro: </h4> <textarea type="text" placeholder={UserIntro}  
                                             onChange={(e) => setUserIntro_(e.target.value)}/>
                        </div>

                        <div> 
                            <button className="Profile-button1" onClick={CancelEdit}><h6>Cancel</h6> </button><br/>
                            <button className="Profile-button2" onClick={handleSave}><h6>Save</h6> </button><br/>
                        </div>
                    </div>
                    </div>
                ):(
                    <div className="Profile">
                    <h1> Personal Information</h1>
                    <div className="Profile-Language" onClick={ChangeToChinese}> <h3>中文</h3></div>
                    
                    <div className="Profile-box">
                        <div className="Profile-Img"> 
                            <p>Profile Pocture</p>
                            <img src={UserProfileImg} alt="Profile Poiture"/>
                        </div>

                        <div className="Profile-Infor"> 
                            <h3>Name: </h3> <p>{UserName}</p>
                            <h4>Intro: </h4> <h6>{UserIntro}</h6>
                        </div>

                        <div> 
                        <button className="Profile-button" onClick={handleEdit}><h6>Edit</h6> </button><br/>
                        </div>
                    </div>
                    </div>
                )}
                </>
            ):(
                <>
                {Edit?(
                    <div className="Profile">
                    <h1> 个人信息 </h1>
                    <div className="Profile-Language" onClick={ChangeToEnglish}> <h3>English</h3></div>
                    
                    <div className="Profile-box">
                        <div className="Profile-Img"> 
                            <p> 头像 </p>
                            <img src={UserProfileImg} alt="头像"/>
                            <input type="file"  onChange={handleEditImg} id="inputImg"/>
                            <label htmlFor="inputImg">选择头像</label>
                            <h6>{Message}</h6>
                        </div>

                        <div className="Profile-Infor"> 
                            <h3>名字: </h3> <input type="text" placeholder={UserName}  
                                             onChange={(e) => setUserName_(e.target.value)}/>
                            <h4>简介: </h4> <textarea type="text" placeholder={UserIntro}  
                                             onChange={(e) => setUserIntro_(e.target.value)}/>
                        </div>

                        <div> 
                            <button className="Profile-button1" onClick={CancelEdit}><h6>取消</h6> </button><br/>
                            <button className="Profile-button2" onClick={handleSave}><h6>保存</h6> </button><br/>
                        </div>
                    </div>
                    </div>
                ):(
                    <div className="Profile">
                    <h1> 个人信息 </h1>
                    <div className="Profile-Language" onClick={ChangeToEnglish}> <h3>English</h3></div>
                    
                    <div className="Profile-box">
                        <div className="Profile-Img"> 
                            <p> 头像 </p>
                            <img src={UserProfileImg} alt="头像_"/>
                        </div>

                        <div className="Profile-Infor"> 
                            <h3>名字: </h3> <p>{UserName}</p>
                            <h4>简介: </h4> <h6>{UserIntro}</h6>
                        </div>

                        <div> 
                        <button className="Profile-button" onClick={handleEdit}><h6>修改</h6> </button><br/>
                        </div>
                    </div>
                    </div>
                )}
                </>
            )}
        </div>  
    );
}
